<template>
    <div class="header-component">
        <div class="logo" @click="BackToHome">
              C-GRAN
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        BackToHome() {
            if (this.$route.name !== 'home') {
                this.$router.push('/')
            }
        }
    }
}
</script>
<style lang="less" scoped>
.header-component {
    background: linear-gradient(90deg, #9ac3f6, #deeafb);
    height: 64px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    .logo {
        font-weight: 900;
        color: #fff;
        font-size: 24px;
        padding: 6px 12px;
        border: 2px solid #fff;
        display: inline-block;
        border-radius: 4px;
        text-shadow: 2px 2px 3px rgba(0,0,0,0.3);
        font-family: system-ui, Avenir, Helvetica, Arial, sans-serif;
        cursor: pointer;
    }
}
</style>